var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "divider-section",
    class: {
      'isBold': _vm.isBold
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "plus-icon-container-mobile"
  }, [_c('div', {
    staticClass: "line"
  }), _c('svg', {
    attrs: {
      "width": "21",
      "height": "20",
      "viewBox": "0 0 21 20",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5 1C11.5 0.447715 11.0523 0 10.5 0C9.94772 0 9.5 0.447715 9.5 1V9H1.5C0.947715 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11H9.5V19C9.5 19.5523 9.94772 20 10.5 20C11.0523 20 11.5 19.5523 11.5 19V11H19.5C20.0523 11 20.5 10.5523 20.5 10C20.5 9.44772 20.0523 9 19.5 9H11.5V1Z",
      "fill": "currentColor"
    }
  })])]), _c('div', {
    staticClass: "divider-label caps-medium"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "line-container"
  }, [_c('div', {
    staticClass: "arrow-container"
  }, [_c('svg', {
    staticStyle: {
      "shape-rendering": "geometricPrecision",
      "text-rendering": "geometricPrecision",
      "image-rendering": "optimizeQuality",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      "width": "0.087126in",
      "height": "0.153417in",
      "version": "1.1",
      "viewBox": "0 0 0.63 1.12"
    }
  }, [_c('path', {
    staticClass: "fil0",
    attrs: {
      "fill": "currentColor",
      "id": "Line_x0020_0.svg",
      "d": "M0.02 0.5c-0.03,0.03 -0.03,0.08 0,0.11l0.48 0.48c0.03,0.03 0.08,0.03 0.11,0 0.03,-0.03 0.03,-0.08 0,-0.11l-0.43 -0.43 0.43 -0.43c0.03,-0.03 0.03,-0.08 0,-0.11 -0.03,-0.03 -0.08,-0.03 -0.11,0l-0.48 0.48z"
    }
  })])]), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "plus-icon-container"
  }, [_c('div', {
    staticClass: "line line-mobile"
  }), _c('svg', {
    attrs: {
      "width": "21",
      "height": "20",
      "viewBox": "0 0 21 20",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5 1C11.5 0.447715 11.0523 0 10.5 0C9.94772 0 9.5 0.447715 9.5 1V9H1.5C0.947715 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11H9.5V19C9.5 19.5523 9.94772 20 10.5 20C11.0523 20 11.5 19.5523 11.5 19V11H19.5C20.0523 11 20.5 10.5523 20.5 10C20.5 9.44772 20.0523 9 19.5 9H11.5V1Z",
      "fill": "currentColor"
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }